// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1573":"4ca04d04e11fbc7c","3434":"88261abbf7bd47c8","3980":"089e249651bcef0e","6155":"af75bb31e580e1fe","7050":"7da70021176c3070","7926":"c6c35e14f6e8d3ce"}[chunkId] + ".css";
};